import React, { useState } from 'react';
import { ChordedLyrics } from './ChordedLyrics';
export const LyricsView = () => {
  const [activeLine, setActiveLine] = useState(0);
  const lyrics = ['Hmm', 'Eyes blue and hollow', 'As it rains against their will', 'Feathers falling out of the pillow', 'As if time is standing still', "I can't remember much more", 'But I know it happened quiet', 'So quiet'];
  // Update chord positions to match specific words
  const chords = ['', 'Em', 'C G', 'Am Em', 'C G', 'Am Em', 'C G D', 'Em'];
  const handleLineClick = (index: number) => {
    setActiveLine(index);
  };
  return <div className="flex-1 bg-gradient-to-b from-[#5e1818] to-[#121212] text-white overflow-y-auto p-8" data-id="element-19">
      <div className="mt-8 max-w-3xl mx-auto" data-id="element-20">
        <ChordedLyrics lyrics={lyrics} chords={chords} activeLine={activeLine} onLineClick={handleLineClick} attribution="© 2018 AURORA" data-id="element-21" />
        {activeLine !== undefined && chords[activeLine] && <div className="mt-8 p-4 bg-[#181818] rounded-md" data-id="element-22">
            <h3 className="text-xl font-bold mb-2" data-id="element-23">Chord Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-24">
              {chords[activeLine].split(/\s+/).filter(Boolean).map((chord, index) => chord && <div key={index} className="p-4 bg-[#282828] rounded-md" data-id="element-25">
                        <h4 className="text-lg font-bold text-[#1DB954] mb-3" data-id="element-26">
                          {chord}
                        </h4>
                        <div className="space-y-4" data-id="element-27">
                          <div data-id="element-28">
                            <h5 className="text-sm font-semibold mb-1" data-id="element-29">
                              Guitar
                            </h5>
                            <p className="font-mono text-sm" data-id="element-30">
                              {getGuitarPosition(chord)}
                            </p>
                          </div>
                          <div data-id="element-31">
                            <h5 className="text-sm font-semibold mb-1" data-id="element-32">
                              Piano
                            </h5>
                            <p className="font-mono text-sm" data-id="element-33">
                              {getPianoNotes(chord)}
                            </p>
                          </div>
                        </div>
                      </div>)}
            </div>
            <p className="mt-4 text-sm text-[#b3b3b3]" data-id="element-34">
              Guitar: Numbers represent fret positions (0 = open string, X =
              muted)
              <br data-id="element-35" />
              Piano: Notes are listed from lowest to highest
            </p>
          </div>}
      </div>
    </div>;
};
// Helper function for guitar positions
function getGuitarPosition(chord: string): string {
  const positions: Record<string, string> = {
    Am: 'X02210 (E A C E)',
    C: 'X32010 (C E G C)',
    D: 'XX0232 (D A D F#)',
    Em: '022000 (E B E G B)',
    G: '320003 (G B D G B D)'
  };
  return positions[chord] || 'Custom chord';
}
// Helper function for piano notes
function getPianoNotes(chord: string): string {
  const notes: Record<string, string> = {
    Am: 'A3 C4 E4 (root position) or C4 E4 A4 (1st inversion)',
    C: 'C3 E3 G3 (root position) or E3 G3 C4 (1st inversion)',
    D: 'D3 F#3 A3 (root position) or F#3 A3 D4 (1st inversion)',
    Em: 'E3 G3 B3 (root position) or G3 B3 E4 (1st inversion)',
    G: 'G3 B3 D4 (root position) or B3 D4 G4 (1st inversion)'
  };
  return notes[chord] || 'Custom chord';
}